module.exports = __webpack_public_path__ + "static/media/lola-astanova.4d77aa29.jpg";